import { Panel } from 'primereact/panel'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  Btn,
  CustomCalendar,
  CustomDropdown,
  CustomMultiSelect,
  CustomCardColorBar,
  PageHeader,
  SectionTitle,
  TextBtn,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import useProdutividadeSeparacao, { LOAD_MESSAGE } from './ProdutividadeSeparacaoHook'
import { parseToMysqlFormat } from '../../../../services/util/date.service'
import CustomPieChart from '../../../../components/CustomPieChart/CustomPieChart'
import * as colors from '../../../../assets/js/colors'

function ProdutividadeSeparacao({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useProdutividadeSeparacao()

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.FETCH_INITIAL_INFO:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getCompaniesAssociatedToUser()
        break

      case LOAD_MESSAGE.GET_PICKINGS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getPickingsPorEmpresa(
          state.companySelected.id,
          selectedTp,
          parseToMysqlFormat(state.pInicial),
          parseToMysqlFormat(state.pFinal),
        )
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    if (state.successMessage) {
      dispatch(showMessageBox(state.successMessage))
      localDispatch.resetState()
    }
  }, [state.successMessage])

  useEffect(() => {
    localDispatch.onInit()
  }, [selectedTp])

  const temDadosPickings = state.pickingOptions && state.pickingOptions.length > 0
  const temRelatorio = !!state.report

  return (
    <>
      <PageHeader>1.6 - Produtividade de Separação</PageHeader>
      <div style={{ marginTop: 16, minHeight: '80vh' }}>
        <Panel header={<TextBtn onClick={history.goBack}>Voltar</TextBtn>}>
          <div className="p-grid p-justify-center">
            <div className="p-grid p-col-12">
              <div className="p-col-12 p-lg-3">
                <CustomDropdown
                  showLabel={true}
                  label="Empresa"
                  optionLabel={'name'}
                  marginTop={10}
                  filter={true}
                  options={state.companies}
                  value={state.companySelected}
                  onChange={value => localDispatch.onCompanyChange(value)}
                />
              </div>

              <div className="p-col-12 p-lg-3">
                <CustomCalendar
                  label={'Período Inicial'}
                  value={state.pInicial}
                  onChange={value => localDispatch.onPeriodoInicialChange(value)}
                />
              </div>

              <div className="p-col-12 p-lg-3">
                <CustomCalendar
                  label={'Período Final'}
                  value={state.pFinal}
                  onChange={value => localDispatch.onPeriodoFinalChange(value)}
                />
              </div>

              <div className="p-col-fixed">
                <div style={{ marginLeft: 10, paddingTop: 27 }}>
                  <Btn
                    onClick={() =>
                      localDispatch.onBtnPesquisar(
                        state.companySelected,
                        selectedTp,
                        state.pInicial,
                        state.pFinal,
                      )
                    }
                  >
                    Pesquisar
                  </Btn>
                </div>
              </div>
            </div>
          </div>

          {temDadosPickings && (
            <div className="p-grid p-col-12" style={{ marginTop: 16 }}>
              <div className="p-col-12 p-lg-4">
                <CustomMultiSelect
                  label="Pickings"
                  options={state.pickingOptions}
                  value={state.selectedPickings}
                  onChange={localDispatch.onPickingsChange}
                  optionLabel="label"
                />
              </div>

              <div className="p-col-12 p-lg-4">
                <CustomMultiSelect
                  label="Equipes"
                  options={state.teamOptions}
                  value={state.selectedTeams}
                  onChange={localDispatch.onTeamsChange}
                  optionLabel="label"
                />
              </div>

              <div className="p-col-12 p-lg-3">
                <CustomMultiSelect
                  label="Usuários"
                  options={state.userOptions}
                  value={state.selectedUsers}
                  onChange={localDispatch.onUsersChange}
                  optionLabel="label"
                />
              </div>

              <div className="p-col-12 p-lg-1" style={{ textAlign: 'right' }}>
                <div style={{ marginTop: 20 }}>
                  <label style={{ fontSize: '0.8rem', display: 'block', visibility: 'hidden' }}>
                    &nbsp;
                  </label>
                  <div style={{ marginTop: 3 }}>
                    <Btn onClick={() => localDispatch.onGerarRelatorio()}>Gerar relatório</Btn>
                  </div>
                </div>
              </div>
            </div>
          )}

          {temRelatorio && (
            <>
              {/* SEPARAÇÃO */}
              <SectionTitle title="Separação" />
              <div className="p-grid p-col-12" style={{ minHeight: '400px' }}>
                <div className="p-col-12 p-lg-4">
                  <CustomPieChart
                    title="Status"
                    height={190}
                    items={state.report.separacao.statusPieData}
                    cellColors={state.report.separacao.statusPieColors}
                  />
                </div>

                <div className="p-col-12 p-sm-6 p-lg-2">
                  <div style={{ height: '200px', display: 'flex', flexDirection: 'column' }}>
                    <CustomCardColorBar
                      value={state.report.separacao.totalVolumes}
                      title={'Total Volumes'}
                      barColor={colors.azul}
                    />
                  </div>
                </div>

                <div className="p-col-12 p-sm-6 p-lg-2">
                  <div style={{ height: '200px', display: 'flex', flexDirection: 'column' }}>
                    <CustomCardColorBar
                      value={state.report.separacao.volumesSeparados}
                      title={'Volumes Separados'}
                      barColor={colors.verde}
                    />
                  </div>
                </div>

                <div className="p-col-12 p-sm-6 p-lg-2">
                  <div style={{ height: '200px', display: 'flex', flexDirection: 'column' }}>
                    <CustomCardColorBar
                      value={state.report.separacao.percentVolSeparado + ' %'}
                      title={'% Vol Separados'}
                      barColor={colors.laranja}
                    />
                  </div>
                </div>
              </div>

              {/* TEMPOS */}
              <SectionTitle title="Tempos" />
              <div className="p-grid p-col-12" style={{ minHeight: '250px' }}>
                <div className="p-col-12 p-sm-6 p-lg-3">
                  <div style={{ height: '200px', display: 'flex', flexDirection: 'column' }}>
                    <CustomCardColorBar
                      value={state.report.tempos.tempoTotal}
                      title={'Tempo total'}
                      barColor={colors.azul}
                    />
                  </div>
                </div>

                <div className="p-col-12 p-sm-6 p-lg-3">
                  <div style={{ height: '200px', display: 'flex', flexDirection: 'column' }}>
                    <CustomCardColorBar
                      value={
                        <>
                          <div>{state.report.tempos.paradasAcima10} parada(s)</div>
                          <div>{state.report.tempos.tempoTotalParado}</div>
                        </>
                      }
                      title={'Paradas acima de 10 min'}
                      barColor={colors.vermelho}
                    />
                  </div>
                </div>

                <div className="p-col-12 p-sm-6 p-lg-3">
                  <div style={{ height: '200px', display: 'flex', flexDirection: 'column' }}>
                    <CustomCardColorBar
                      value={state.report.tempos.maiorParada}
                      title={'Maior parada'}
                      subTitle={`${state.report.tempos.inicioMaiorParada} até ${state.report.tempos.fimMaiorParada}`}
                      barColor={colors.vinho}
                    />
                  </div>
                </div>

                <div className="p-col-12 p-sm-6 p-lg-3">
                  <div style={{ height: '200px', display: 'flex', flexDirection: 'column' }}>
                    <CustomCardColorBar
                      value={state.report.tempos.tempoLiquido}
                      title={'Tempo Líquido'}
                      barColor={colors.verde}
                    />
                  </div>
                </div>
              </div>

              {/* PRODUTIVIDADE */}
              <SectionTitle title="Produtividade" />
              <div className="p-grid p-col-12">
                <div className="p-col-12">
                  <DataTable
                    value={state.report.produtividade}
                    emptyMessage="Nenhum usuário selecionado"
                    style={{ width: '100%' }}
                  >
                    <Column field="name" header="Usuário" />
                    <Column field="qtdSeparadas" header="Qtd separadas" />
                    <Column field="pesoTotal" header="Peso Total Separado *" />
                    <Column field="tempo" header="Tempo" />
                    <Column field="bipsMin" header="Caixas/min" />
                  </DataTable>
                  <small style={{ display: 'block', marginTop: 8, color: '#777' }}>
                    * O Peso Total Separado é baseado no valor do Peso Bruto por Caixa/Volume
                    cadastrado para cada produto separado pelo usuário. Produtos cadastrados com
                    valores errados poderão interferir na integridade do valor total
                    exibido/calculado
                  </small>
                </div>
              </div>
            </>
          )}
        </Panel>
      </div>
    </>
  )
}

const mapStateToProps = state => {
  return {
    selectedTp: state.system.selectedTp,
  }
}

export default connect(mapStateToProps)(withRouter(ProdutividadeSeparacao))
